import { API_URL } from '../../../constants';
import makeUrl from '../../utils/makeUrl';
import _fetch from '../../_fetch';

export default function createNde(data, options = {}) {
  return function withContext(context) {
    const url = makeUrl(API_URL, 'ndes', options);

    console.log(data);
    const config = {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        'Accept': 'application/json;charset=utf-8',
        'Content-Type': 'application/json;charset=utf-8'
      },
      ...options.reqConfig
    };

    return _fetch(url, {
      withAuth: false,
      ...options
    }, config)(context);
  };
}
